import React from "react";
import { toast } from "react-toastify";
import translator from "./translator";

export const toastUtil = (param) => {
	try {
			
		var currentLanguage = param?.currentLanguage;
		var data = param?.data;
		var success = param?.success??false;
		var warning = param?.warning??true;

		if(!data?.error && data?.error !== '' && !data?.result){
			debugger;
			console.error("Error not recognized");
			console.error(data);
		}
		else
		if (!data?.error) {
			
			if(data?.result?.status === 'Success' && success) {
					toast.success(translator(currentLanguage, 'Success'));
			}
			if(data?.result?.status !== 'Success' && warning){
					toast.warn(translator(currentLanguage, data?.result?.message));
			}
		}
		else{
			var errorCode = data?.error?.code;
			switch(errorCode){
				case 401: 
				case 403: 
					document.dispatchEvent(
						new CustomEvent("medapp_session_unauthorized", {
						bubbles: true,
						detail: { text: "unauthorized" },
						})
					);
					break;
				default:
					toast.error(data?.action + " UNEXPECTED ERROR:" + (data?.result?.message ?? data?.error));
					break;
			}
		}
	} catch (error) {
		
	}
};

export const toastUtilText = (currentLanguage, type, text) => {
	if (type?.toLowerCase() === "success") {
		toast.success(translator(currentLanguage, text));
	}
	if (type?.toLowerCase() === "warning") {
		toast.warn(translator(currentLanguage, text));
	}
	if (type?.toLowerCase() === "info") {
		toast.info(translator(currentLanguage, text));
	}
	if (type?.toLowerCase() === "error") {
		toast.error(translator(currentLanguage, text));
	}
};


export default toastUtil;
